import { render, staticRenderFns } from "./AndersonVianna.vue?vue&type=template&id=18843619"
import script from "./AndersonVianna.vue?vue&type=script&lang=js"
export * from "./AndersonVianna.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports